import { isNumber } from 'radash';

import { ZoneHelpers } from '@diagram/helpers/ZoneHelpers';

import { Diagram, DiagramConnection, ZoneValidationError, ZoneValidationErrorType, ZoneValidator } from 'models';

const getVoltageType = (diagram: Diagram, connection: DiagramConnection) => {
    const { from, to } = connection;
    if (!isNumber(from.port) || !isNumber(to.port)) return null;
    const fromVT = diagram.componentInstances[from.componentInstanceId]?.configuration.ports?.[from.port]?.voltageType;
    const toVT = diagram.componentInstances[to.componentInstanceId]?.configuration.ports?.[to.port]?.voltageType;
    return fromVT === toVT ? fromVT : null;
};

const checkZoneVoltageTypes: ZoneValidator['validator'] = ({ diagram, zones }) => {
    const errors: ZoneValidationError[] = [];

    zones.forEach((zone) => {
        const voltageTypes: {
            AC: DiagramConnection[];
            DC: DiagramConnection[];
            undefined: DiagramConnection[];
        } = {
            AC: [],
            DC: [],
            undefined: [],
        };

        zone.connections.forEach((connection) => {
            const voltageType = getVoltageType(diagram, connection);

            if (voltageType) {
                voltageTypes[voltageType].push(connection);
            } else {
                voltageTypes.undefined.push(connection);
            }
        });

        if (voltageTypes.undefined.length) {
            ZoneHelpers.error(errors, ZoneValidationErrorType.VOLTAGE_TYPES_MISSING, zone);
        } else if (voltageTypes.AC.length && voltageTypes.DC.length) {
            ZoneHelpers.warning(errors, ZoneValidationErrorType.VOLTAGE_TYPES_MISMATCH, zone);
        }
    });

    return errors;
};

export { checkZoneVoltageTypes };
